import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from "react";

type Announce = (message: string) => void;
const AnnouncerContext = createContext<Announce>(() => {});

/** A polite live region for confirmations such as "Household created" (also shown as a visible toast). */
export function AnnouncerProvider({ children }: { children: ReactNode }) {
  const [message, setMessage] = useState<{ text: string; id: number } | null>(null);
  const announce = useCallback<Announce>((text) => {
    setMessage((previous) => ({ text, id: (previous?.id ?? 0) + 1 }));
    window.setTimeout(() => setMessage((current) => (current?.text === text ? null : current)), 5000);
  }, []);
  const value = useMemo(() => announce, [announce]);
  return (
    <AnnouncerContext.Provider value={value}>
      {children}
      <div className="cc-toast-region" role="status" aria-live="polite">
        {message ? (
          <div key={message.id} className="cc-toast">
            {message.text}
          </div>
        ) : null}
      </div>
    </AnnouncerContext.Provider>
  );
}

export const useAnnounce = () => useContext(AnnouncerContext);
